import {Loan} from '../../model/loan.model';
import {LoanListFilter} from './loan-list.filter';
import {ConfigService} from '../../service/config.service';
import moment = require('moment');
import {Injectable} from '@angular/core';

@Injectable()
export class NpaLoansFilter extends LoanListFilter {
    private readonly configService: ConfigService;

    constructor(configService: ConfigService) {
        super();
        this.configService = configService;
    }

    onFilterApplied(loan: Loan): boolean {
        const onGoingEmiDelay = loan.emi_delay_details.emi_delay.find(delay => !delay.is_delay_amount_paid);
        const delayStartCycle = moment(onGoingEmiDelay.due_date).endOf('day');
        const numberOfDaysDelayed = moment().endOf('day').diff(delayStartCycle, 'day');
        const npaDays = this.configService.getNpaDays();
        return numberOfDaysDelayed >= npaDays;
    }
}
